// Obnovovanie zoznamu úloh podľa potreby (#165, 23. 9. 2026).
// Dovtedy sa zoznam obnovoval každých 5 s natrvalo — 1 907 požiadaviek za deň
// od jedného klienta aj hodiny bez aktivity. Teraz: pri aktívnych úlohách
// každé 3 s (plynulý priebeh), inak 60 s, na skrytej karte vôbec. Ďalšie
// obnovenie sa plánuje až po dokončení predchádzajúceho, aby sa požiadavky
// neprekrývali. Po odoslaní súboru (udalosť JOBS_CHANGED) sa obnoví hneď.
import { useEffect, useRef } from 'react';

export const JOBS_CHANGED = 'cenzor:jobs-changed';
export const notifyJobsChanged = () => {
  try { window.dispatchEvent(new Event(JOBS_CHANGED)); } catch (e) { /* nič */ }
};

const useAdaptivePolling = (fetchFn, isActive, { activeMs = 3000, idleMs = 60000 } = {}) => {
  const fnRef = useRef(fetchFn);
  fnRef.current = fetchFn;

  useEffect(() => {
    let timer = null;
    let zruseny = false;
    let bezi = false;

    const spusti = async () => {
      if (zruseny || bezi) return;
      clearTimeout(timer);
      if (document.hidden) return;
      bezi = true;
      try { await fnRef.current(); } catch (e) { /* chybu rieši fetchFn */ }
      bezi = false;
      if (!zruseny && !document.hidden) timer = setTimeout(spusti, isActive ? activeMs : idleMs);
    };

    timer = setTimeout(spusti, isActive ? activeMs : idleMs);
    const priZmene = () => { if (!document.hidden) spusti(); };
    document.addEventListener('visibilitychange', priZmene);
    window.addEventListener(JOBS_CHANGED, priZmene);
    return () => {
      zruseny = true;
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', priZmene);
      window.removeEventListener(JOBS_CHANGED, priZmene);
    };
  }, [isActive, activeMs, idleMs]);
};

export default useAdaptivePolling;
